(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-media-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('premium-review-reel')) {
  customElements.define('premium-review-reel', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.abort || !this.isConnected) return;
      this.viewport = this.querySelector('.pvr-viewport');
      if (!this.viewport) return;
      this.abort = new AbortController();
      this.on = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.abort.signal });
      this.track = this.querySelector('.pvr-track');
      this.original = this.querySelector('[data-original]');
      this.cards = Array.from(this.original.children);
      this.playable = this.cards.filter(card => card.dataset.usable === 'true');
      this.dialog = this.querySelector('.pvr-dialog');
      this.contentElement = this.querySelector('[data-dialog-content]');
      this.motion = this.querySelector('[data-motion]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reduced.matches || this.dataset.editor === 'true';
      this.direction = this.dataset.direction === 'right' ? -1 : 1;
      this.speed = Number(this.dataset.speed) || 28;
      this.fraction = 0;
      this.loopSignature = null;
      this.lastTime = 0;
      this.visible = true;
      this.manualUntil = 0;
      this.updateMotion();
      this.on(this.reduced, 'change', () => {
        if (this.reduced.matches) { this.userPaused = true; this.updateMotion(); }
      });

      this.on(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (this.suppressClick && button.hasAttribute('data-open')) {
          event.preventDefault(); this.suppressClick = false; return;
        }
        if (button.hasAttribute('data-open')) this.open(button.dataset.open, button);
        else if (button.hasAttribute('data-close')) this.close();
        else if (button.hasAttribute('data-motion')) {
          this.userPaused = !this.userPaused; this.updateMotion();
          // A deliberate resume click may continue even while the button has focus.
          this.focusPaused = false;
        }
        else if (button.hasAttribute('data-previous')) this.move(-1);
        else if (button.hasAttribute('data-next')) this.move(1);
        else if (button.hasAttribute('data-dialog-previous')) this.nextReview(-1);
        else if (button.hasAttribute('data-dialog-next')) this.nextReview(1);
        else if (button.hasAttribute('data-toggle')) this.toggleMedia();
        else if (button.hasAttribute('data-mute')) this.toggleMute();
        else if (button.hasAttribute('data-speed-button')) this.changeSpeed(button);
      });
      this.on(this.viewport, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.on(this.viewport, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hover === 'true') this.hovered = true;
      });
      this.on(this.viewport, 'pointerleave', () => { this.hovered = false; });
      this.on(this, 'focusin', event => {
        if (event.target.matches(':focus-visible')) this.focusPaused = true;
      });
      this.on(this, 'focusout', () => {
        queueMicrotask(() => { this.focusPaused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); });
      });
      this.on(this.viewport, 'wheel', () => this.hold(), { passive: true });
      this.on(this.viewport, 'scroll', () => this.normalize(), { passive: true });
      this.on(this.viewport, 'dragstart', event => event.preventDefault());
      this.on(this.viewport, 'pointerdown', event => {
        this.hold(); this.touching = true; this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { x: event.clientX, scroll: this.viewport.scrollLeft, pointer: event.pointerId, moved: false };
      });
      this.on(window, 'pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.pointer) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 6) {
          this.drag.moved = true;
          this.viewport.classList.add('is-dragging');
          this.viewport.scrollLeft = this.drag.scroll - delta;
        }
      });
      const release = () => {
        if (this.drag?.moved) { this.suppressClick = true; this.hold(); }
        this.drag = null; this.touching = false; this.viewport.classList.remove('is-dragging');
      };
      this.on(window, 'pointerup', release);
      this.on(window, 'pointercancel', release);
      this.on(window, 'blur', release);
      this.on(document, 'visibilitychange', () => {
        if (document.hidden) this.pauseMedia();
      });
      this.on(document, 'pvr:open', event => { if (event.detail !== this) this.close(); });
      this.on(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
      this.on(this.dialog, 'close', () => this.cleanupDialog());
      this.on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
      this.on(this.dialog, 'keydown', event => {
        if (event.target.matches('input, textarea, select, summary')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.nextReview(event.key === 'ArrowRight' ? 1 : -1);
        }
      });

      this.on(document, 'shopify:block:select', event => {
        const key = event.detail?.blockId;
        const card = this.cards.find(item => item.dataset.key === key);
        if (!card) return;
        this.editorSelected = true;
        this.close();
        const cardLeft = card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
        this.viewport.scrollLeft = cardLeft - (this.viewport.clientWidth - card.offsetWidth) / 2;
      });
      this.on(document, 'shopify:block:deselect', () => { this.editorSelected = false; });
      this.resizeObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.buildLoop());
      });
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.original);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (!this.visible) this.pauseMedia();
      }, { threshold: 0.01 });
      this.intersectionObserver.observe(this);
      this.buildLoop();
      this.tick = now => {
        const elapsed = Math.min(now - (this.lastTime || now), 60);
        this.lastTime = now;
        if (this.canScroll(now)) {
          this.fraction += this.direction * this.speed * elapsed / 1000;
          const pixels = Math.trunc(this.fraction);
          if (pixels) { this.viewport.scrollLeft += pixels; this.fraction -= pixels; this.normalize(); }
        }
        this.frame = requestAnimationFrame(this.tick);
      };
      this.frame = requestAnimationFrame(this.tick);
    }

    canScroll(now) {
      return this.dataset.auto === 'true' && this.looping && this.visible && !document.hidden && !this.userPaused && !this.hovered && !this.focusPaused && !this.touching && !this.editorSelected && !this.dialog.open && now > this.manualUntil;
    }

    buildLoop() {
      if (!this.isConnected) return;
      const width = this.viewport.clientWidth;
      const runWidth = this.original.getBoundingClientRect().width;
      const signature = `${width}:${runWidth}:${this.cards.length}`;
      if (signature === this.loopSignature) return;
      this.loopSignature = signature;
      const previousIndex = this.runWidth ? (this.viewport.scrollLeft % this.runWidth) / this.runWidth : 0;
      this.track.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
      this.classList.remove('is-static');
      this.runWidth = this.original.getBoundingClientRect().width;
      this.looping = this.cards.length > 1 && this.runWidth > width;
      if (this.looping) {
        for (let i = 0; i < 2; i++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-original'); copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true'); copy.removeAttribute('role');
          copy.querySelectorAll('template').forEach(template => template.remove());
          copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach(element => {
            element.removeAttribute('id'); element.removeAttribute('data-shopify-editor-block');
          });
          copy.querySelectorAll('button, a, input, [tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
          if (i === 0) this.track.prepend(copy); else this.track.append(copy);
        }
        this.viewport.scrollLeft = this.runWidth * (1 + previousIndex);
      } else {
        this.classList.add('is-static'); this.viewport.scrollLeft = 0;
      }
      this.querySelectorAll('[data-previous], [data-next], [data-motion]').forEach(button => { button.disabled = !this.looping; });
      this.normalize();
    }

    normalize() {
      if (!this.looping || !this.runWidth) return;
      const left = this.viewport.scrollLeft;
      let shift = 0;
      if (!this.focusPaused && !this.editorSelected) {
        if (left < this.runWidth * .25) shift = this.runWidth;
        else if (left > this.runWidth * 1.75) shift = -this.runWidth;
      }
      if (shift) { this.viewport.scrollLeft += shift; if (this.drag) this.drag.scroll += shift; }
      const progress = this.querySelector('[data-reel-progress]');
      if (progress) progress.style.transform = `translateX(${(this.viewport.scrollLeft % this.runWidth) / this.runWidth * 300}%)`;
    }

    hold() { this.manualUntil = performance.now() + 3500; }
    move(direction) {
      if (!this.cards.length || !this.looping) return;
      this.hold();
      const gap = parseFloat(getComputedStyle(this.original).gap) || 0;
      this.viewport.scrollBy({ left: direction * (this.cards[0].offsetWidth + gap), behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    updateMotion() {
      if (!this.motion) return;
      this.motion.classList.toggle('is-paused', this.userPaused);
      this.motion.setAttribute('aria-pressed', String(this.userPaused));
      this.motion.setAttribute('aria-label', this.userPaused ? this.motion.dataset.playLabel : this.motion.dataset.pauseLabel);
    }

    open(key, trigger) {
      const card = this.playable.find(item => item.dataset.key === key);
      if (!card) return;
      document.dispatchEvent(new CustomEvent('pvr:open', { detail: this }));
      this.releaseMedia();
      if (trigger) this.returnFocus = trigger;
      this.activeIndex = this.playable.indexOf(card);
      this.contentElement.replaceChildren(card.querySelector('template').content.cloneNode(true));
      this.dialog.querySelector('[data-dialog-count]').textContent = `${this.activeIndex + 1} / ${this.playable.length}`;
      this.dialog.querySelectorAll('[data-dialog-previous], [data-dialog-next]').forEach(button => { button.disabled = this.playable.length < 2; });
      if (!this.dialog.open) {
        this.previousOverflow = document.documentElement.style.overflow;
        this.locked = true;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }
      this.dialog.scrollTop = 0;
      this.setupMedia();
    }

    setupMedia() {
      this.mediaAbort = new AbortController();
      const signal = this.mediaAbort.signal;
      this.master = this.contentElement.querySelector('[data-master]');
      this.video = this.contentElement.querySelector('video');
      this.seek = this.contentElement.querySelector('[data-seek]');
      if (!this.master) return;
      const master = this.master;
      const video = this.video;
      const detachedVoice = video && video !== master;
      master.volume = Math.max(0, Math.min(1, Number(this.dataset.volume) / 100));
      master.loop = this.dataset.loop === 'true';
      if (detachedVoice) { video.muted = true; video.loop = true; }
      const on = (target, name, fn) => target?.addEventListener(name, fn, { signal });
      const update = () => {
        if (this.master !== master) return;
        const duration = Number.isFinite(master.duration) ? master.duration : 0;
        const elapsed = master.currentTime || 0;
        this.contentElement.querySelector('[data-time]').textContent = `${this.formatTime(elapsed)} / ${this.formatTime(duration)}`;
        this.seek.disabled = duration <= 0;
        this.seek.value = duration ? elapsed / duration * 100 : 0;
        this.seek.style.setProperty('--played', `${this.seek.value}%`);
        this.seek.setAttribute('aria-valuetext', `${this.formatTime(elapsed)} / ${this.formatTime(duration)}`);
      };
      const playing = value => {
        if (this.master !== master) return;
        this.classList.toggle('is-playing', value);
        const toggle = this.contentElement.querySelector('[data-toggle]');
        toggle?.setAttribute('aria-label', value ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      };
      on(master, 'playing', () => { playing(true); this.showMessage(''); if (detachedVoice && video.paused) video.play().catch(() => {}); });
      on(master, 'pause', () => { playing(false); if (detachedVoice) video.pause(); });
      on(master, 'waiting', () => { playing(false); if (detachedVoice) video.pause(); });
      on(master, 'ended', () => { playing(false); if (detachedVoice) video.pause(); update(); });
      on(master, 'loadedmetadata', update);
      on(master, 'durationchange', update);
      on(master, 'timeupdate', () => {
        update();
        if (detachedVoice && Number.isFinite(video.duration) && video.duration > 0) {
          const target = master.currentTime % video.duration;
          if (Math.abs(video.currentTime - target) > .5 && !video.seeking) video.currentTime = target;
        }
      });
      on(master, 'error', () => { this.pauseMedia(); this.showMessage(this.dataset.error); });
      if (detachedVoice) on(video, 'error', () => this.showMessage(this.dataset.error));
      on(master, 'volumechange', () => this.updateMute());
      on(this.seek, 'input', () => {
        if (!Number.isFinite(master.duration)) return;
        master.currentTime = Number(this.seek.value) / 100 * master.duration;
        if (detachedVoice && Number.isFinite(video.duration) && video.duration > 0) video.currentTime = master.currentTime % video.duration;
        update();
      });
      update(); this.updateMute();
      this.playMedia();
    }

    playMedia() {
      const master = this.master;
      if (!master) return;
      if (master.ended) master.currentTime = 0;
      const video = this.video;
      if (video && video !== master) video.play().catch(() => {});
      master.play().catch(error => {
        if (this.master !== master) return;
        this.classList.remove('is-playing');
        if (video && video !== master) video.pause();
        if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') this.showMessage(this.dataset.error);
      });
    }
    pauseMedia() {
      this.master?.pause(); this.video?.pause(); this.classList.remove('is-playing');
    }
    toggleMedia() { if (this.master?.paused) this.playMedia(); else this.pauseMedia(); }
    toggleMute() {
      if (!this.master) return;
      const wasMuted = this.master.muted || this.master.volume === 0;
      this.master.muted = !wasMuted;
      if (wasMuted && this.master.volume === 0) this.master.volume = .8;
      this.updateMute();
    }
    updateMute() {
      const button = this.contentElement.querySelector('[data-mute]');
      if (!button || !this.master) return;
      const muted = this.master.muted || this.master.volume === 0;
      button.setAttribute('aria-pressed', String(muted));
      button.setAttribute('aria-label', muted ? button.dataset.unmuteLabel : button.dataset.muteLabel);
    }
    changeSpeed(button) {
      if (!this.master) return;
      const rates = [1, 1.25, 1.5, 2];
      const rate = rates[(rates.indexOf(this.master.playbackRate) + 1) % rates.length];
      this.master.playbackRate = rate;
      if (this.video) this.video.playbackRate = rate;
      button.textContent = `${rate}×`;
    }
    formatTime(seconds) {
      if (!Number.isFinite(seconds)) return '0:00';
      const whole = Math.max(0, Math.floor(seconds));
      return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
    }
    showMessage(text) {
      const message = this.contentElement.querySelector('[data-message]');
      if (message) { message.textContent = text; message.hidden = !text; }
    }
    nextReview(direction) {
      if (!this.playable.length) return;
      const index = (this.activeIndex + direction + this.playable.length) % this.playable.length;
      this.open(this.playable[index].dataset.key);
    }
    close() {
      // Run cleanup synchronously; the native close event may arrive later.
      if (this.dialog?.open) this.dialog.close();
      this.cleanupDialog();
    }
    cleanupDialog() {
      // Do not tear down a new viewer opened before the previous close event.
      if (this.dialog?.open) return;
      this.releaseMedia();
      this.contentElement?.replaceChildren();
      if (this.locked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      this.hold();
    }
    releaseMedia() {
      this.pauseMedia();
      this.mediaAbort?.abort(); this.mediaAbort = null;
      this.contentElement?.querySelectorAll('audio, video').forEach(media => {
        media.removeAttribute('src'); media.querySelectorAll('source').forEach(source => source.removeAttribute('src')); media.load();
      });
      this.master = null; this.video = null;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.resizeFrame);
      this.close(); this.abort?.abort(); this.abort = null;
      this.resizeObserver?.disconnect(); this.intersectionObserver?.disconnect();
      this.track?.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
